module.exports = __webpack_public_path__ + "static/media/jamie-sparker-acting-reel.0281f2ae.jpg";